// import formatNumber from '@/formatters/formatNumber'
export default {
  methods: {
    openColumnsHelper({ type = 'helper', slug, id }) {
      this.$eventBus.$emit('openDrawerContent', { type, id: id, slug })      
    },
  }
}